/** Leave notes are capped at this many words (also enforced by the API). */
export const REASON_MAX_WORDS = 30;

export function wordCount(text: string): number {
  const t = text.trim();
  return t ? t.split(/\s+/).length : 0;
}

/** Cuts `text` to at most `max` words, keeping the original spacing of what stays. */
export function limitWords(text: string, max: number = REASON_MAX_WORDS): string {
  const re = /\S+/g;
  let count = 0;
  let lastEnd = 0;
  let m: RegExpExecArray | null;
  while ((m = re.exec(text)) !== null) {
    count++;
    if (count > max) return text.slice(0, lastEnd);
    lastEnd = m.index + m[0].length;
  }
  return text;
}
